module.exports = __webpack_public_path__ + "media/2x/male-female@2x-07918e4a.png";